import type { ReactNode } from 'react'
import { useAuth } from '@/hooks/use-auth'

interface CanProps {
  permission: string
  children: ReactNode
  fallback?: ReactNode
}

export function Can({ permission, children, fallback = null }: CanProps) {
  const { can } = useAuth()
  return can(permission) ? <>{children}</> : <>{fallback}</>
}
